(function () {
    "use strict";
    angular.module('app').directive('habilCheckbox', HabilCheckboxDirective);
    
    HabilCheckboxDirective.$inject = [];
    function HabilCheckboxDirective() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                uniqueName: '@',
                valueObject: '=',
                label: '@',
                onClick: '&',
                readonly: '='
            },
            template: `
            <div class="custom-control custom-checkbox">
                <input type="checkbox" ng-click="onClick()"
                    class="custom-control-input custom-check"
                    name="{{uniqueName}}" ng-attr-id="{{uniqueName}}"
                    ng-model="valueObject"
                    ng-disabled="readonly">
                <label class="custom-control-label" style="padding-left: 5px;" for="{{uniqueName}}">
                    {{label}}
                </label>
            </div>`,
        };
    }
})();